module.exports = __webpack_public_path__ + "static/media/block.567b4933.svg";